









































import { defineComponent } from '@nuxtjs/composition-api';
import Button from '~/components/atoms/Buttons/Button/Button.vue';
import InformationBox from '~/components/atoms/InformationBox/InformationBox.vue';
import { INFORMATION_BOX_TYPE } from '~/components/atoms/InformationBox/InformationBoxType';

export default defineComponent({
  name: 'WebformShortcut',
  components: {
    Button,
    InformationBox,
  },
  props: {
    shortcutUrl: {
      type: String,
      required: true,
    },
    shortcutButtonText: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      INFORMATION_BOX_TYPE,
    };
  },
});
